/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChiusuraSaveDTO
 */
export interface ChiusuraSaveDTO {
    /**
     * 
     * @type {Date}
     * @memberof ChiusuraSaveDTO
     */
    data?: Date;
    /**
     * 
     * @type {string}
     * @memberof ChiusuraSaveDTO
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChiusuraSaveDTO
     */
    giacenzaFinale?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChiusuraSaveDTO
     */
    maggiorazioneUscite?: number | null;
}

/**
 * Check if a given object implements the ChiusuraSaveDTO interface.
 */
export function instanceOfChiusuraSaveDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChiusuraSaveDTOFromJSON(json: any): ChiusuraSaveDTO {
    return ChiusuraSaveDTOFromJSONTyped(json, false);
}

export function ChiusuraSaveDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChiusuraSaveDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : (new Date(json['data'])),
        'note': !exists(json, 'note') ? undefined : json['note'],
        'giacenzaFinale': !exists(json, 'giacenzaFinale') ? undefined : json['giacenzaFinale'],
        'maggiorazioneUscite': !exists(json, 'maggiorazioneUscite') ? undefined : json['maggiorazioneUscite'],
    };
}

export function ChiusuraSaveDTOToJSON(value?: ChiusuraSaveDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : (value.data.toISOString()),
        'note': value.note,
        'giacenzaFinale': value.giacenzaFinale,
        'maggiorazioneUscite': value.maggiorazioneUscite,
    };
}

